// /**
//  * Market selector.
//  * - Opens a popup listing configured markets.
//  * - Redirects to the chosen market's URL.
//  * - Optionally auto-opens once per visitor on first visit (cookie-gated).
//  * - Clones the header trigger into the mobile navigation drawer footer.
//  */
// (function () {
//   'use strict';

//   var DISMISS_COOKIE = 'abelstedt_market_dismissed';
//   var COOKIE_DAYS = 365;

//   /**
//    * @param {string} name
//    * @returns {?string}
//    */
//   function getCookie(name) {
//     var match = ('; ' + document.cookie).split('; ' + name + '=');
//     if (match.length === 2) return match.pop().split(';').shift();
//     return null;
//   }

//   /**
//    * @param {string} name
//    * @param {string} value
//    * @param {number} days
//    */
//   function setCookie(name, value, days) {
//     var expires = '';
//     if (days) {
//       var date = new Date();
//       date.setTime(date.getTime() + days * 86400000);
//       expires = '; expires=' + date.toUTCString();
//     }
//     document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
//   }

//   function getModal() {
//     return document.getElementById('header-market-popup');
//   }

//   /**
//    * Moves the popup to <body> so it escapes the header's stacking context
//    * (.pageheader has z-index: 4000), otherwise the cart drawer paints over it.
//    * Also removes any stale copy left behind by a theme-editor section reload.
//    */
//   function portalModal() {
//     document.querySelectorAll('body > [data-market-portaled]').forEach(function (stale) {
//       stale.remove();
//     });
//     var modal = getModal();
//     if (modal && modal.parentNode !== document.body) {
//       modal.setAttribute('data-market-portaled', '');
//       document.body.appendChild(modal);
//     }
//   }

//   function openPopup() {
//     var modal = getModal();
//     if (modal && typeof modal.open === 'function') modal.open();
//   }

//   function dismiss() {
//     setCookie(DISMISS_COOKIE, '1', COOKIE_DAYS);
//   }

//   /**
//    * @param {HTMLElement} btn
//    */
//   function redirectFromButton(btn) {
//     var url = btn.getAttribute('data-market-url');
//     if (!url) return;
//     dismiss();
//     window.location.href = url;
//   }

//   /**
//    * Wires open/close/redirect handlers. Safe to call more than once for cloned nodes.
//    * @param {ParentNode} root
//    */
//   function bindTriggers(root) {
//     root.querySelectorAll('[data-market-open]').forEach(function (btn) {
//       if (btn.dataset.marketBound) return;
//       btn.dataset.marketBound = '1';
//       btn.addEventListener('click', function (evt) {
//         evt.preventDefault();
//         openPopup();
//       });
//     });
//   }

//   function bindPopup() {
//     var modal = getModal();
//     if (!modal || modal.dataset.marketBound) return;
//     modal.dataset.marketBound = '1';

//     modal.querySelectorAll('[data-market-url]').forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         redirectFromButton(btn);
//       });
//     });

//     modal.querySelectorAll('[data-market-stay]').forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         dismiss();
//         if (typeof modal.close === 'function') modal.close();
//       });
//     });
//   }

//   function maybeAutoOpen() {
//     if (window.Shopify && window.Shopify.designMode) return;
//     var modal = getModal();
//     if (!modal || !modal.hasAttribute('data-market-auto-open')) return;
//     if (getCookie(DISMISS_COOKIE)) return;

//     if (window.customElements && customElements.whenDefined) {
//       customElements.whenDefined('modal-dialog').then(openPopup);
//     } else {
//       openPopup();
//     }
//   }

//   /**
//    * Clones the header trigger into the mobile navigation drawer footer so the
//    * market selector is reachable on mobile.
//    */
//   function cloneToMobile() {
//     var theme = window.theme;
//     if (!theme || typeof theme.suffixIds !== 'function') return;

//     var headerWrapper = document.querySelector('.pageheader [data-market-wrapper]');
//     var mobileFooter = document.querySelector('.mobile-navigation-drawer__footer');
//     if (!headerWrapper || !mobileFooter) return;
//     if (mobileFooter.querySelector('[data-market-wrapper]')) return;

//     var clone = headerWrapper.cloneNode(true);
//     theme.suffixIds(clone, 'MobileNav');
//     delete clone.dataset.marketBound;
//     clone.querySelectorAll('[data-market-open]').forEach(function (btn) {
//       delete btn.dataset.marketBound;
//     });

//     mobileFooter.insertBefore(clone, mobileFooter.firstChild);
//     bindTriggers(clone);
//   }

//   function init() {
//     portalModal();
//     bindTriggers(document);
//     bindPopup();
//     maybeAutoOpen();

//     if (window.customElements && customElements.whenDefined) {
//       customElements.whenDefined('page-header').then(function () {
//         setTimeout(cloneToMobile, 0);
//       });
//     } else {
//       setTimeout(cloneToMobile, 0);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   // Re-bind after a header re-render in the theme editor.
//   document.addEventListener('shopify:section:load', init);
// })();


/**
 * Market selector.
 * - Opens a popup listing configured markets.
 * - Redirects to the chosen market's URL.
 * - Optionally auto-opens once per visitor on first visit (cookie-gated).
 * - Clones the header trigger into the mobile navigation drawer footer.
 */
(function () {
  'use strict';

  var DISMISS_COOKIE = 'abelstedt_market_dismissed';
  var COOKIE_DAYS = 365;

  /**
   * @param {string} name
   * @returns {?string}
   */
  function getCookie(name) {
    var match = ('; ' + document.cookie).split('; ' + name + '=');
    if (match.length === 2) return match.pop().split(';').shift();
    return null;
  }

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   */
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 86400000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function getModal() {
    return document.getElementById('header-market-popup');
  }

  /**
   * Moves the popup to <body> so it escapes the header's stacking context
   * (.pageheader has z-index: 4000), otherwise the cart drawer paints over it.
   * Also removes any stale copy left behind by a theme-editor section reload.
   */
  function portalModal() {
    document.querySelectorAll('body > [data-market-portaled]').forEach(function (stale) {
      stale.remove();
    });
    var modal = getModal();
    if (modal && modal.parentNode !== document.body) {
      modal.setAttribute('data-market-portaled', '');
      document.body.appendChild(modal);
    }
  }

  function openPopup() {
    var modal = getModal();
    if (modal && typeof modal.open === 'function') modal.open();
  }

  function dismiss() {
    setCookie(DISMISS_COOKIE, '1', COOKIE_DAYS);
  }

  /**
   * @param {HTMLElement} btn
   */
  function redirectFromButton(btn) {
    var url = btn.getAttribute('data-market-url');
    if (!url) return;
    dismiss();
    window.location.href = url;
  }

  /**
   * Wires open/close/redirect handlers. Safe to call more than once for cloned nodes.
   * @param {ParentNode} root
   */
  function bindTriggers(root) {
    root.querySelectorAll('[data-market-open]').forEach(function (btn) {
      if (btn.dataset.marketBound) return;
      btn.dataset.marketBound = '1';
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        openPopup();
      });
    });
  }

  function bindPopup() {
    var modal = getModal();
    if (!modal || modal.dataset.marketBound) return;
    modal.dataset.marketBound = '1';

    modal.querySelectorAll('[data-market-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        redirectFromButton(btn);
      });
    });

    modal.querySelectorAll('[data-market-stay]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dismiss();
        if (typeof modal.close === 'function') modal.close();
      });
    });
  }

  function maybeAutoOpen() {
    if (window.Shopify && window.Shopify.designMode) return;
    var modal = getModal();
    if (!modal || !modal.hasAttribute('data-market-auto-open')) return;
    if (getCookie(DISMISS_COOKIE)) return;

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('modal-dialog').then(openPopup);
    } else {
      openPopup();
    }
  }

  /**
   * Clones the header trigger into the mobile navigation drawer footer so the
   * market selector is reachable on mobile.
   */
  function cloneToMobile() {
    var theme = window.theme;
    if (!theme || typeof theme.suffixIds !== 'function') return;

    var headerWrapper = document.querySelector('.pageheader [data-market-wrapper]');
    var mobileFooter = document.querySelector('.mobile-navigation-drawer__footer');
    if (!headerWrapper || !mobileFooter) return;
    if (mobileFooter.querySelector('[data-market-wrapper]')) return;

    var clone = headerWrapper.cloneNode(true);
    theme.suffixIds(clone, 'MobileNav');
    delete clone.dataset.marketBound;
    clone.querySelectorAll('[data-market-open]').forEach(function (btn) {
      delete btn.dataset.marketBound;
    });

    mobileFooter.insertBefore(clone, mobileFooter.firstChild);
    bindTriggers(clone);
  }

  /**
   * Clones the header trigger into the footer market slot ([data-market-footer-slot])
   * so the selector is reachable from the footer too. Reuses the single popup
   * (#header-market-popup) and the already-loaded script/CSS — nothing is rendered
   * or loaded twice. No-op if the footer has no slot or the header has no selector.
   */
  function cloneToFooter() {
    var slot = document.querySelector('[data-market-footer-slot]');
    if (!slot || slot.querySelector('[data-market-wrapper]')) return;

    var headerWrapper = document.querySelector('.pageheader [data-market-wrapper]');
    if (!headerWrapper) return;

    var clone = headerWrapper.cloneNode(true);
    delete clone.dataset.marketBound;
    clone.querySelectorAll('[data-market-open]').forEach(function (btn) {
      delete btn.dataset.marketBound;
    });

    slot.appendChild(clone);
    bindTriggers(slot);
  }

  function init() {
    portalModal();
    bindTriggers(document);
    bindPopup();
    maybeAutoOpen();

    function cloneTriggers() {
      cloneToMobile();
      cloneToFooter();
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('page-header').then(function () {
        setTimeout(cloneTriggers, 0);
      });
    } else {
      setTimeout(cloneTriggers, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after a header re-render in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();